import http from "../../http/requests/shift/index.js";

export default {
  fetchShift(context, shiftID) {
    return new Promise((resolve, reject) => {
      http
        .fetchShift(shiftID)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA SINGLE SHIFT");
          console.log(error);
          reject(error);
        });
    });
  },
  fetchShifts({ commit }) {
    return new Promise((resolve, reject) => {
      http
        .fetchShifts()
        .then(response => {
          commit("SET_SHIFTS", response.data);
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA SHIFTS");
          console.log(error);
          reject(error);
        });
    });
  },
  addShift({ commit }, payload) {
    return new Promise((resolve, reject) => {
      http
        .addShift(payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA ADD SHIFT");
          console.log(error);
          reject(error);
        });
    });
  },
  editShift({ commit }, payload) {
    return new Promise((resolve, reject) => {
      http
        .editShift(payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA EDIT SHIFT");
          console.log(error);
          reject(error);
        });
    });
  },
  deleteShift(context, shiftID) {
    return new Promise((resolve, reject) => {
      http
        .deleteShift(shiftID)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA DELETE SHIFT");
          console.log(error);
          reject(error);
        });
    });
  }
};